const DASF_ERROR_MSG = 'DASF_errorMessage';

export const setDasfLoginScreenErrorMsg = (errorMsg): void => {
    sessionStorage.setItem(DASF_ERROR_MSG, errorMsg);
};
